export const StatusTooltip = (props: { value?: string | null }) => {
  const raw = (props?.value ?? '').toString();
  if (!raw.trim()) return null;

  const lines = raw
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  return (
    <div
      className="flex w-full max-w-[420px] flex-col gap-1 whitespace-pre-line rounded-md border border-white/10 bg-[#232323] px-2 py-2 text-[0.75rem] leading-5 text-white shadow-[0_10px_24px_rgba(0,0,0,0.35)]"
    >
      {lines.map((line, index) => {
        const match = /^(Reason|Start|End|Updated):\s*(.*)$/.exec(line);
        if (match) {
          const [, label, value] = match;
          return (
            <div key={`${label}-${index}`}>
              <span className="font-semibold">{label}:</span> {value}
            </div>
          );
        }

        return <div key={`line-${index}`}>{line}</div>;
      })}
    </div>
  );
};

export const CellValueTooltip = (props: { value?: string | null }) => {
  const text = (props?.value ?? '').toString().trim();
  if (!text) return null;

  return (
    <div className="relative z-[1200] max-w-[42rem] whitespace-normal break-words rounded-md border border-white/10 bg-[#232323] px-2 py-1 text-[0.8125rem] leading-5 text-white shadow-[0_10px_24px_rgba(0,0,0,0.35)]">
      {text}
    </div>
  );
};
